<template>
	<div>
		<el-dialog title :visible.sync="dialogVisible" width="600px" :modal="true" custom-class="dialog-one">
			<div class="login-wrap">
				<div class="box1">
					<img class="logo" :src="logo_img" alt="" />
				</div>
				<div class="box2 flex-item-center" @click="closeDialog">
					<img class="inner1" src="../../../assets/images/base/pc/action2.png" alt="" />
				</div>
				<div class="box3">
					<el-form ref="form" class="login-form" label-position="left" :model="form" :rules="rules">
						<div class="inner1">登入帳號</div>
						<el-form-item prop="username" style="margin-bottom: 15px">
							<el-input name="username" v-model.trim="form.username" placeholder="請填寫帳號" tabindex="1"
								type="text" autoComplete="username" />
						</el-form-item>
						<div class="inner1">輸入密碼</div>
						<el-form-item prop="password">
							<el-input name="password" ref="password" v-model.trim="form.password" placeholder="請填寫密碼"
								tabindex="2" type="password" autoComplete="current-password"
								@keyup.enter.native="handleLogin" />
						</el-form-item>
					</el-form>
					<el-button class="inner2" :loading="loginBtn" @click="loginConform">登入</el-button>
					<div class="inner3 flex-item-center">
						<div class="floor1 flex-item-center" @click="showReg">馬上註冊</div>
						<div class="floor2"></div>
						<div class="floor1 flex-item-center" @click="backHome">
							回到首頁
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog title :visible.sync="dialogVisibleReg" width="996px" top="95px" :modal="true"
			custom-class="dialog-one">
			<div class="reg-wrap">
				<div class="box1">
					<img class="logo" :src="logo_img" alt="" />
				</div>
				<div class="box2 flex-item-center" @click="closeDialogReg">
					<img class="inner1" src="../../../assets/images/base/pc/action2.png" alt="" />
				</div>
				<div class="box3">
					<!-- :rules="regRules" -->
					<el-form ref="regForm" class="login-form" label-position="left" :model="regForm">
						<div class="inner1">真實姓名</div>
						<el-form-item prop="name" style="margin-bottom: 15px">
							<el-input v-model.trim="regForm.name" placeholder="輸入真實姓名" tabindex="1" type="text" />
						</el-form-item>
						<div class="inner1">手機號碼</div>
						<el-form-item prop="mobile">
							<el-input v-model.trim="regForm.mobile" placeholder="輸入手機號碼" tabindex="1" type="text" />
						</el-form-item>
						<div class="inner4">
							為了維護您的權利，註冊姓名/身分證/帳戶
							須為同一人。請使用本人手機號碼且可接收簡訊。禁止利用多重身分申請大量帳號，造成職員資料重疊或點數遺失，後果自負。
						</div>
						<div class="inner1">帳號名稱</div>
						<el-form-item prop="account">
							<el-input v-model.trim="regForm.account" placeholder="帳號需為3~20英數組合" tabindex="1"
								type="text" />
						</el-form-item>
						<div class="base-flex-between">
							<div style="width: 333px">
								<div class="inner1">輸入密碼</div>
								<el-form-item prop="password" style="margin-bottom: 15px">
									<el-input ref="password" v-model.trim="regForm.password" placeholder="輸入密碼"
										tabindex="2" type="password" />
								</el-form-item>
							</div>
							<div style="width: 333px">
								<div class="inner1">再次輸入密碼</div>
								<el-form-item prop="cPassword" style="margin-bottom: 15px">
									<el-input v-model.trim="regForm.cPassword" placeholder="輸入密碼" tabindex="1"
										type="password" />
								</el-form-item>
							</div>
						</div>
						<!-- <div style="width: 100%">
              <div class="inner1">提款密碼</div>
              <el-form-item prop="tkPassword" style="margin-bottom: 15px">
                <el-input
                  ref="password"
                  v-model.trim="regForm.tkPassword"
                  placeholder="提款密碼"
                  tabindex="2"
                  type="password"
                  maxlength="6"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                />
              </el-form-item>
            </div> -->
						<div class="base-flex-between">
							<div style="width: 333px">
								<div class="inner1">通訊軟體</div>
								<el-form-item prop="line" style="margin-bottom: 15px">
									<el-input v-model.trim="regForm.line" placeholder="輸入LINE ID" tabindex="1"
										type="text" />
								</el-form-item>
							</div>
							<!--              <div style="width: 333px">-->
							<!--                <div class="inner1">通訊軟體</div>-->
							<!--                <el-form-item prop="wechat" style="margin-bottom: 15px">-->
							<!--                  <el-input-->
							<!--                    v-model.trim="regForm.wechat"-->
							<!--                    placeholder="輸入WECHAT ID"-->
							<!--                    tabindex="1"-->
							<!--                    type="text"-->
							<!--                  />-->
							<!--                </el-form-item>-->
							<!--              </div>-->
						</div>
						<!-- <div class="inner1">輸入驗證碼</div>
            <div class="base-flex-between" style="margin-bottom: 22px">
              <el-form-item prop="code" style="width: 530px; margin-bottom: 0">
                <el-input
                  v-model.trim="regForm.code"
                  placeholder="輸入驗證碼"
                  tabindex="1"
                  type="text"
                />
              </el-form-item>
              <img
                @click="getCodeImg"
                style="width: 147px; height: auto; cursor: pointer"
                :src="codeImgUrl"
                alt=""
              />
            </div> -->
					</el-form>
					<div style="display: flex; cursor: pointer" @click="changeXieyi">
						<img style="
                width: 14px;
                height: 14px;
                position: relative;
                top: 2px;
                margin-right: 8px;
              " v-show="!xieyiBtn" src="../../../assets/images/base/pc/select2.png" alt="" />
						<img style="
                width: 14px;
                height: 14px;
                position: relative;
                top: 2px;
                margin-right: 8px;
              " v-show="xieyiBtn" src="../../../assets/images/base/pc/select1.png" alt="" />
						<div style="font-size: 13px; color: #000">
							<span>確認本人已滿18歲且在此網站的所有活動，並沒有抵觸本人所身在的國家所管轄的法律。本人也接受在此項申請下有關的所有</span>
							<span style="color: #396294">規則與條例以及隱私權聲明。</span>
						</div>
					</div>
					<el-button class="inner2" :loading="loginBtn" @click="regConform">註冊</el-button>
					<div class="inner3 flex-item-center">
						<div class="floor1 flex-item-center">聯繫客服</div>
						<div class="floor2"></div>
						<div class="floor1 flex-item-center" @click="hasAccount">
							已有帳號
						</div>
						<div class="floor2"></div>
						<div class="floor1 flex-item-center" @click="backHome">
							回到首頁
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState, mapGetters, mapMutations } from "vuex";
	import bus from "./bus";
	import { getLogo } from "@/api/index";
	import { downLoadUrl } from "@/config/net.config.js";
	import { login_pwd, register, verify } from "@/api/index";
	export default {
		name: "baseHeader",
		props: {
			msg: String,
		},
		computed: {
			...mapState(["isLogin"]),
		},

		data() {
			return {
				dialogVisible: false,
				loginBtn: false,
				form: {
					username: "",
					password: "",
				},
				rules: {
					username: [{
						required: true,
						trigger: "blur",
						message: "請輸入帳號",
						// validator: validatePhone,
					}, ],
					password: [{
						required: true,
						trigger: "blur",
						message: "請輸入密碼",
					}, ],
				},
				regForm: {
					name: "",
					mobile: "",
					account: "",
					password: "",
					cPassword: "",
					line: "",
					wechat: "",
					code: "",
					tkPassword: "",
				},
				regRules: {
					name: [{
						required: true,
						trigger: "blur",
						message: "请输入真實姓名",
						// validator: validatePhone,
					}, ],
					mobile: [{
						required: true,
						trigger: "blur",
						message: "请输入手機號碼",
					}, ],
					account: [{
						required: true,
						trigger: "blur",
						message: "请输入帳號名稱",
					}, ],
					password: [{
						required: true,
						trigger: "blur",
						message: "輸入密碼",
					}, ],
					cPassword: [{
						required: true,
						trigger: "blur",
						message: "輸入密碼",
					}, ],
					line: [{
						required: true,
						trigger: "blur",
						message: "輸入LINE ID",
					}, ],
					wechat: [{
						required: true,
						trigger: "blur",
						message: "輸入WECHAT ID",
					}, ],
					// code: [
					//   {
					//     required: true,
					//     trigger: "blur",
					//     message: "輸入驗證碼",
					//   },
					// ],
				},
				dialogVisibleReg: false,
				xieyiBtn: false,
				codeImgUrl: "",
				downLoadUrl,
				logo_img: ''
			};
		},
		created() {},
		mounted() {
			this.getLogo();
		},
		methods: {
			changeXieyi() {
				this.xieyiBtn = !this.xieyiBtn;
			},
			openDialog() {
				this.dialogVisible = true;
			},
			openDialogReg() {
				this.dialogVisibleReg = true;
				this.getCodeImg();
			},
			closeDialog() {
				this.dialogVisible = false;
			},
			closeDialogReg() {
				this.dialogVisibleReg = false;
			},
			hasAccount() {
				this.dialogVisibleReg = false;
				setTimeout(() => {
					this.dialogVisible = true;
				}, 300);
			},
			backHome() {
				this.closeDialog();
				this.closeDialogReg();
				this.$router.push("/");
			},
			getCodeImg() {
				let params = {};
				verify(params)
					.then((res) => {
						console.log(res, "resssss");
						this.codeImgUrl = downLoadUrl + res;
						console.log(this.codeImgUrl, "this.codeImgUrl");
						// if (res.code == 0) {

						// } else {
						//   this.$toast(res.msg);
						// }
					})
					.catch((err) => {});
			},
			loginConform() {
				let params = {
					username: this.form.username,
					password: this.form.password,
				};
				if (!this.form.username) {
					this.$message.error("请输入登入帳號");
					return;
				}
				if (!this.form.password) {
					this.$message.error("请輸入密碼");
					return;
				}
				this.loginBtn = true;
				login_pwd(params)
					.then((res) => {
						this.loginBtn = false;
						console.log(res, "res");
						if (res.code == 0) {
							this.closeDialog();
							this.$message({
								message: "登入成功",
								type: "success",
							});
							this.$store.commit("changeIsLogin", true);
							this.$store.commit("changeIsLogin", true);
							localStorage.setItem("Token", res.token);
							localStorage.setItem("uid", res.uid);
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.loginBtn = false;
					});
				// this.$refs.form.validate((valid) => {
				//   if (valid) {
				//     this.$store.commit('changeIsLogin', true);
				//     this.closeDialog();
				//   } else {
				//     return false
				//   }
				// })
			},
			regConform() {
				if (!this.regForm.name) {
					this.$message.error("请输入真實姓名");
					return;
				}
				if (!this.regForm.mobile) {
					this.$message.error("请输入手機號碼");
					return;
				}
				if (!this.regForm.account) {
					this.$message.error("请輸入登入帳號");
					return;
				}
				if (!this.regForm.password || !this.regForm.cPassword) {
					this.$message.error("请輸入密碼");
					return;
				}
				if (this.regForm.password != this.regForm.cPassword) {
					this.$message.error("兩次密碼輸入不一致");
					return;
				}
				// if (!this.regForm.tkPassword) {
				//   this.$message.error("请輸入提款密碼");
				//   return;
				// }
				// if (this.regForm.tkPassword.length<4 || this.regForm.tkPassword.length>6) {
				//   this.$message.error("提款密碼必須為4-6位");
				//   return;
				// }
				if (!this.regForm.line && !this.regForm.wechat) {
					this.$message.error("請輸入通訊軟體");
					return;
				}
				// if (!this.regForm.code) {
				//   this.$message.error("請輸入驗證碼");
				//   return;
				// }

				if (!this.regForm.password) {
					this.$message.error("请輸入密碼");
					return;
				}
				if (!this.xieyiBtn) {
					this.$message.error("請先閱讀並同意協議");
					return;
				}
				let params = {
					realname: this.regForm.name,
					mobile: this.regForm.mobile,
					password: this.regForm.password,
					password2: this.regForm.cPassword,
					line_id: this.regForm.line,
					wechat_id: this.regForm.wechat,
					username: this.regForm.account,
					code: this.regForm.code,
					pay_pwd: this.regForm.tkPassword,
				};
				this.loginBtn = true;
				register(params)
					.then((res) => {
						this.loginBtn = false;
						if (res.code == 0) {
							this.closeDialogReg();
							this.$message({
								message: "註冊成功",
								type: "success",
							});
							this.$store.commit("changeIsLogin", true);
							localStorage.setItem("Token", res.token);
							localStorage.setItem("uid", res.uid);
							// this.closeDialog();
						} else {
							this.$message.error(res.msg);
							this.getCodeImg();
						}
					})
					.catch((err) => {
						this.loginBtn = false;
						this.getCodeImg();
					});
				// this.$refs.regForm.validate((valid) => {
				//   if (valid) {
				//     if (!this.xieyiBtn) {
				//       this.$message.error('请先阅读并同意协议')
				//       return
				//     }
				//   } else {
				//     return false
				//   }
				// })
			},
			showReg() {
				this.dialogVisible = false;
				setTimeout(() => {
					this.dialogVisibleReg = true;
					this.getCodeImg();
				}, 300);
			},
			// 获取logo
			async getLogo () {
				let params = {
					father_id: 0,
				};
				let res = await getLogo(params);
				if (res.code != 0) return;
				this.logo_img = this.downLoadUrl + res.data.logo_img;
			}
		},
	};
</script>

<style scoped lang="scss">
	::v-deep .el-dialog__header {
		display: none;
	}

	::v-deep .el-dialog {
		background: #fff !important;
		border-radius: 10px !important;
	}

	::v-deep .el-dialog__body {
		padding: 0;
		border: none;
		background: #fff !important;
		border-radius: 10px !important;
	}

	.login-wrap,
	.reg-wrap {
		width: 100%;
		position: relative;
		padding-top: 0.1rem;

		.box1 {
			width: 45%;
			height: 120px;
			display: flex;
			justify-content: center;
			margin: 0 auto;
			position: relative;
			
			.logo{
				width: 100%;
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
			}
		}

		.box2 {
			position: absolute;
			right: 0;
			top: 0;
			padding: 16px;
			cursor: pointer;

			.inner1 {
				width: 28px;
				height: 28px;
			}
		}

		.box3 {
			padding: 35px 115px 20px;
			padding-top: 10px;

			.inner1 {
				font-size: 15px;
				color: #000;
				font-weight: 600;
				margin-bottom: 15px;
			}

			.login-form {
				::v-deep .el-form-item__content {
					display: flex;
					align-items: center;
					height: 44px;
					border-radius: 4px;
					width: 100%;
					padding: 0 11px;
					background-color: #dddddd;
				}

				::v-deep .el-input__inner {
					background-color: #dddddd !important;
					border: none !important;
					height: 44px;
					font-size: 16px;
					color: #333;
					padding: 0 0;
					position: relative;
					border-radius: 0;

					&::placeholder {
						color: #999999;
					}
				}

				::v-deep .el-input {
					background-color: #fff !important;
				}

				::v-deep .el-form-item__error {
					padding-top: 2px;
				}
			}

			.inner2 {
				background-color: #396294;
				border-radius: 4px;
				width: 100%;
				border: none;
				height: 48px;
				font-size: 15px;
				color: #fff;
				font-weight: 600;
				margin: 20px 0 6px;
			}

			.inner3 {
				.floor1 {
					padding: 20px;
					cursor: pointer;
					font-size: 15px;
					color: #87868a;
					font-weight: 600;
				}

				.floor2 {
					margin: 0 26px;
					width: 1px;
					height: 22px;
					background: #919094;
					border-radius: 4px;
				}
			}

			.inner4 {
				font-size: 13px;
				color: #396294;
				font-weight: 600;
				margin-bottom: 13px;
			}
		}
	}
</style>